import React from 'react';

import classNames from 'classnames';
import './styles.css';

const WarningField = ({touched, warning, className}: any) => {
  return (
    <div className={classNames(className)}>
      {touched && warning && <div className="WarningField">{warning}</div>}
    </div>
  );
};

export default WarningField;
